const hostname = window && window.location && window.location.hostname;

export const AppConfig = ['localhost:3000', 'localhost:81', 'staging-edp.edseed.me'].indexOf(window.location.host) !== -1 ?
    {
        api: hostname === 'localhost' ? 'http://localhost:81/api/v1' : '/dashboard/api/v1',
        frontend: window.location.origin,
        prefix: hostname === 'localhost' ? '/' : '/dashboard',
        base: window.location.origin + (hostname === 'localhost' ? '' : '/dashboard'),
        ios: 'edseed://www.edseed.me',
        stripe: 'pk_live_I8bQ14hI1VwVO1gJG0n4Tm6V',
        stripeTest: 'pk_test_51GnoLBAdxWFETcomGe78zpgJ9R7O6s6DW1z8PsfeVAOAoUGPGFUfidIw8qL7z927HqNLW7uiXs02h50u7cOU5n5g003PGJcp7P',
        fees: 8,
        interactionTrackerEnabled: true,
        stripeSupportedWallets: ['applePay', 'googlePay', 'browserCard'],
    } :
    {
        api: 'https://www.edseed.me/dashboard/api/v1',
        frontend: 'https://www.edseed.me',
        prefix: '/dashboard',
        base: 'https://www.edseed.me/dashboard',
        ios: 'edseed://www.edseed.me/dashboard',
        stripe: 'pk_live_I8bQ14hI1VwVO1gJG0n4Tm6V',
        stripeTest: 'pk_test_bYpvE6zG82H06krBojIkXFev',
        fees: 8,
        interactionTrackerEnabled: true,
        stripeSupportedWallets: ['applePay', 'googlePay', 'browserCard'],
    }
export const FcmConfig = {
    //apiKey: "AAAA_nZ5kHs:APA91bELPep-QtsWaVNxgXGW6F_emqKo65PlIxmsPBWxVEm-YYT_3gyXzQ2-oTV8sdKLCSPOk7QIwzL4bEKZv4OCl9wK-5DsSYWjiJm83VYcCF9VaUfPUNBgDehGnl5Ma5SogpxiZIwF",
    projectId: "edseed-5bafa",
    messagingSenderId: "879004532585"
}

export const ReCAPTCHAConfig = {
    site_key: '6LfinossAAAAAIYQzDnW_h_5s_f3BSseDGr2p7bm',
    site_key_invisible: '6LfynossAAAAAMl-hqY02zpam8_elZ4a5UoacYNj',
}

export const LocalizationConfig = {
    default: 'en',
    locales: [
        {
            code: 'en',
            name: 'English'
        },
        {
            code: 'ar',
            name: 'Arabic'
        }
    ]
}